// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"78c0671a","703":"9b9fff68","787":"f39bb3cb"}[chunkId] + ".chunk.js";
};